// Auto generated file, do not manually modify!
// com.hotpads.admanagement.api.web.external.handler.AdManagementUserContractsApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  AdManagementUserContractsApiHandler_getDocumentEditorUrl,
  AdManagementUserContractsApiHandler_getDocumentEditorUrl_Path,
  AdManagementUserContractsApiHandler_getSubscriptionContractDetails,
  AdManagementUserContractsApiHandler_getSubscriptionContractDetails_Path,
} from '@zg-rentals/ts-ad-management-client';

import type { AdManagementSubscriptionContractsDto } from '@zg-rentals/ts-ad-management-client';

interface GetDocumentEditorUrlParams {
  documentId: string;
}

export type AdManagementUserContractsApiHandler_getDocumentEditorUrl_Options = UseQueryOptions<
  string,
  unknown,
  string,
  readonly [string, GetDocumentEditorUrlParams]
>;

const AdManagementUserContractsApiHandler_getDocumentEditorUrl_GetKey = (getParams: GetDocumentEditorUrlParams) =>
  [AdManagementUserContractsApiHandler_getDocumentEditorUrl_Path, getParams] as const;

export const AdManagementUserContractsApiHandler_getDocumentEditorUrl_queryOptions = (
  getParams: GetDocumentEditorUrlParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: AdManagementUserContractsApiHandler_getDocumentEditorUrl_GetKey(getParams),
    queryFn: () => AdManagementUserContractsApiHandler_getDocumentEditorUrl(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Return Document editor url
 */
export const useAdManagementUserContractsApiHandler_getDocumentEditorUrl = (
  getParams: GetDocumentEditorUrlParams,
  {
    httpClient,
    ...options
  }: Omit<AdManagementUserContractsApiHandler_getDocumentEditorUrl_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...AdManagementUserContractsApiHandler_getDocumentEditorUrl_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useAdManagementUserContractsApiHandler_getDocumentEditorUrl.getKey =
  AdManagementUserContractsApiHandler_getDocumentEditorUrl_GetKey;

export type AdManagementUserContractsApiHandler_getSubscriptionContractDetails_Options = UseQueryOptions<
  Array<AdManagementSubscriptionContractsDto>,
  unknown,
  Array<AdManagementSubscriptionContractsDto>,
  readonly [string]
>;

const AdManagementUserContractsApiHandler_getSubscriptionContractDetails_GetKey = () =>
  [AdManagementUserContractsApiHandler_getSubscriptionContractDetails_Path] as const;

export const AdManagementUserContractsApiHandler_getSubscriptionContractDetails_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: AdManagementUserContractsApiHandler_getSubscriptionContractDetails_GetKey(),
    queryFn: () => AdManagementUserContractsApiHandler_getSubscriptionContractDetails(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Return Logged in User's Subscription Contracts
 */
export const useAdManagementUserContractsApiHandler_getSubscriptionContractDetails = ({
  httpClient,
  ...options
}: Omit<AdManagementUserContractsApiHandler_getSubscriptionContractDetails_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...AdManagementUserContractsApiHandler_getSubscriptionContractDetails_queryOptions({ httpClient }),
    ...options,
  });
};
useAdManagementUserContractsApiHandler_getSubscriptionContractDetails.getKey =
  AdManagementUserContractsApiHandler_getSubscriptionContractDetails_GetKey;
